// extracted by mini-css-extract-plugin
export default {"features":"Features_features__cJ0bg","featureContainer":"Features_featureContainer__+GKEZ","feature":"Features_feature__lve-3"};